import { Step, type ReturnFlow } from "../return-flow";
import { FlowType } from "../return-flow-enums";
import type { ReturnWindowCondition } from "./agent-return-window-policy";
import { Condition } from "./condition";

export interface AgentReturnWindowRestriction {
  condition: ReturnWindowCondition;
  conditionStep: number;
  continueAt: number;
  rejectionStep: number;
}

/** Select only direct expiry-to-denial gates, never compensation routing. */
export function getAgentReturnWindowRestriction(
  flow: ReturnFlow,
  conditionStep: number,
): AgentReturnWindowRestriction | undefined {
  if (flow.type !== undefined && flow.type !== FlowType.RETURN) {
    return undefined;
  }
  const step = flow.steps[conditionStep];
  if (
    step?.type !== Step.CONDITION ||
    step.nextTrue === undefined ||
    step.nextFalse === undefined ||
    step.nextTrue === conditionStep
  ) {
    return undefined;
  }
  const rejection = flow.steps[step.nextFalse];
  if (rejection?.type !== Step.BLOCK && rejection?.type !== Step.REJECT) {
    return undefined;
  }
  const continuation = flow.steps[step.nextTrue];
  if (
    !continuation ||
    continuation.type === Step.BLOCK ||
    continuation.type === Step.REJECT
  ) {
    return undefined;
  }
  const condition = step.condition;
  if (
    condition.type !== Condition.ORDER_WITHIN &&
    condition.type !== Condition.FULFILLMENT_WITHIN &&
    condition.type !== Condition.DELIVERY_WITHIN
  ) {
    return undefined;
  }
  return {
    condition,
    conditionStep,
    continueAt: step.nextTrue,
    rejectionStep: step.nextFalse,
  };
}
